import { Model, belongsTo } from 'miragejs'
import type { ModelDefinition } from 'miragejs/-types'
import type { SchemaAttributes } from '../types.js'

export type TagData = SchemaAttributes<'Tag'>

export const model = (Model as ModelDefinition<TagData>).extend({
  tagText: belongsTo('tagText'),
})

export function routes() {}
